import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useModalContext } from "../../../modal/context/ModalProvider.js";
import { ApplicationIcon, GroupIcon, UserIcon } from "../../../assets/Icons";
import {
  APPLICATION_TAB_TYPE,
  GROUP_TAB_TYPE,
  RESOURCE_APPLICATION_TAB,
  USER_TAB_TYPE,
} from "../../../constant/constants.js";
import { checkPermissionExist } from "../../../utils/general.js";
import {
  GROUP_CREATE_PERMISSION,
  RESOURCE_REVOKE_PERMISSION,
  USER_CREATE_PERMISSION,
} from "../../../constant/permission.js";

const { NormalGradientButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const Create = ({ currentTab, handleRefreshTab, tabType = null, details = {} }) => {
  const userData = useUnoSelector((state) => state.user);
  const { openModal } = useModalContext();
  const params = useParams();
  const navigate = useNavigate();

  const handleAssignResource = () => {
    if (!tabType || !details?.name) return;
    let selectedData = {
      type: tabType,
      items: [{ name: details.name, uuid: details.uuid, avatar: details.avatar }],
    };
    navigate(`/resource-management/${tabType}/${params.uuid}`, { state: { selectedData } });
  }

  const renderContent = () => {
    switch (currentTab) {
      case USER_TAB_TYPE:
        if (checkPermissionExist(USER_CREATE_PERMISSION)) {
          return (
            <NormalGradientButton
              icon={<UserIcon />}
              text="User"
              onClick={() => openModal({ modalName: "USER_ADD", type: "create", id: null, params, handleRefreshTab })}
            />
          );
        }
        return null;
      case GROUP_TAB_TYPE:
        if (checkPermissionExist(GROUP_CREATE_PERMISSION)) {
          return (
            <NormalGradientButton
              icon={<GroupIcon />}
              text="Group"
              onClick={() => openModal({ modalName: "GROUP_ADD", type: "create", id: null, params, handleRefreshTab })}
            />
          );
        }
        return null;
      case APPLICATION_TAB_TYPE:
        if (checkPermissionExist(RESOURCE_REVOKE_PERMISSION)) {
          return (
            <NormalGradientButton
              icon={<ApplicationIcon />}
              text="Application"
              onClick={() => handleAssignResource()}
            />
          );
        }
        return null;
      // case RESOURCE_APPLICATION_TAB:
      //   if (checkPermissionExist(RESOURCE_REVOKE_PERMISSION)) {
      //     return (
      //       <NormalGradientButton
      //         icon={<ApplicationIcon />}
      //         text="Application"
      //         onClick={() => navigate(`/resource-management/123`)}
      //       />
      //     );
      //   }
      //   return null;
      default:
        <></>;
    }
  };

  return <>{renderContent()}</>;
};

export default Create;
